import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const HeaderActionsPortaled = ({ children }: { children: React.ReactNode }) => {
  const [container, setContainer] = useState<Element | null>(null);

  useEffect(() => {
    let raf = requestAnimationFrame(() => {
      setContainer(document.getElementById('header-actions'));
    });
    return () => cancelAnimationFrame(raf);
  }, []);

  if (!container) return null;
  return createPortal(children, container);
};
